import '@angular/localize/init';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl()
{
	if (environment.production)
		return "https://app-admin.gigey.it/";
	else
		//return 'https://localhost:55873/';
		return 'https://localhost:57305/';
}

const providers =
	[
		{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
	];

if (environment.production)
{
	enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
	.catch(err => console.log(err));